module.exports = __webpack_public_path__ + "static/img/mpm_2.6b9dfcb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mpm_2.jpg
// module id = PT6p
// module chunks = 1